import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const Accessories = lazy(() => import('./Accessories'));
const AccessoriesListView = lazy(() => import('./views/AccessoriesListView'));
const AccessoryFormView = lazy(() => import('./views/AccessoryFormView'));

const AccessoriesRoute: FuseRouteItemType = {
	path: '/catalog/accessory-types',
	element: <Accessories />,
	children: [
		{ index: true, element: <AccessoriesListView /> },
		{ path: 'new', element: <AccessoryFormView /> },
		{ path: ':id', element: <AccessoryFormView /> }
	]
};

export default AccessoriesRoute;
